<template>
<div>
  <div>
    <div class="form-3-header-div">
      <div class="div-block-966">
        <a href="#" class="w-inline-block"><img sizes="(max-width: 479px) 44.8125px, 84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-30"></a>
      </div>
    </div>
  </div>
  <section>
    <div class="div-block-1809">
      <div class="w-layout-blockcontainer container-24 w-container">
        <div class="div-block-1810">
          <div class="text-block-871">You are all set {{ first_name }}!</div>
          <p class="paragraph-138">Based on your responses, the initial <strong>virtual doctor visit is not required.</strong><br></p>
        </div>
        <div class="form-block-6 w-form">
          <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-13" data-wf-page-id="672b26275fa6662390d46c9f" data-wf-element-id="5fe12935-7cda-fd10-56e6-d42fb99b9e4b">
            <div class="bullet-points">
              <div class="div-block-1807"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66e063d26925cab97883e1fe_stepsimage_teledoc.png" alt="" class="image-428">
                <div>
                  <div class="text-block-872">Doctor will review &amp; prescribe.</div>
                  <div class="text-block-873">Our clinicians will review your info &amp; send script to partner pharmacy.</div>
                </div>
              </div>
              <div class="div-block-1807"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66c742632bf62043d3fad823_icon_van.png" alt="" class="image-428">
                <div>
                  <div class="text-block-872">Express Shipping</div>
                  <div class="text-block-873">We will ship your medication express so you can start ASAP!</div>
                </div>
              </div>
              <div class="div-block-1807"><img loading="lazy" src="@/assets/images/icon_doc.png" alt="" class="image-428">
                <div>
                  <div class="text-block-872">Unlimited Clinical Support</div>
                  <div class="text-block-873">Once the medicine arrives you will gain unlimited access to doctors by phone &amp; email to answer any questions.</div>
                </div>
              </div>
              
            </div>
            <div class="div-block-1808">
              <a href="/home" class="button-88 w-button">Login To Your Dashboard</a>
            </div>
          </form>
          <div class="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
        <div class="div-block-1806"></div>
      </div>
    </div>
  </section>
    
</div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: ['baseUrl'],
    components: {

    },
    data() {
        return {
            selTime: "",
            setDate: '',
        }
    },
    computed: {
        first_name() {
            try {
                let k = localStorage.getItem("user_form");
                if (k) {
                    let temp = JSON.parse(k);
                    return temp.first_name;
                }
            } catch (error) {
                console.log(error);

            }
            return "";
        },

    },
    created() {}
}
</script>
